// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App.vue'
import VueResource from 'vue-resource'
import ElementUI from 'element-ui'
import store from './store/store'
import router from './router'
import VueWorker from 'vue-worker'
import locale from 'element-ui/lib/locale/lang/en'
import Mixpanel from './plugins/mixpanel'
import BadRequestInterceptor from './plugins/interceptors/bad_request'
import UnauthorizedRequestInterceptor from './plugins/interceptors/unauthorized_request'
import AuthVerifier from './plugins/authverification/auth_verifier'
// import InstanceSwitchGuard from './plugins/instance_switch_guard'
import PageVisibilityCheck from './plugins/page_visibility_check'
import SigmaPlugin from '@sigmacloud/sigma-client/dist/components/plugins/sigma'
import { enableIgnoreVueWarn } from '@sigmacloud/sigma-client/dist/components/plugins'
import { IS_DEV } from '@sigmacloud/sigma-client/dist/util/env'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import 'element-ui/lib/theme-default/index.css'
import './assets/styles/main.css'

Vue.config.productionTip = false
Vue.use(ElementUI, { locale })
Vue.use(VueResource)
Vue.use(VueWorker)
Vue.use(Mixpanel, { token: process.env.MIXPANEL_TOKEN || '' })
Vue.use(BadRequestInterceptor)
Vue.use(UnauthorizedRequestInterceptor)
Vue.use(AuthVerifier)
// Vue.use(InstanceSwitchGuard)
Vue.use(PageVisibilityCheck)
Vue.use(SigmaPlugin)
Vue.use(BootstrapVue)
Vue.use(IconsPlugin)

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

if (IS_DEV) {
  enableIgnoreVueWarn(Vue)
}

new Vue({
  el: '#app',
  store,
  router,
  render: h => h(App)
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js